<template>
  <Head>
    <title>{{ title }} - {{ setting.brandShortName }}</title>
  </Head>
  <div class="error-img container mx-auto flex items-center justify-center">
    <div class="text-center">
      <div class="mx-auto mb-8 flex max-w-sm flex-col items-center text-center">
        <img
          :src="cdn('images/error-img.svg')"
          alt="error-img"
        >
      </div>
      <h1 class="mb-2 mt-3 text-base font-semibold text-primary-900">
        {{ title.split(":")[0] }} error
      </h1>
      <h1 class="text-2xl font-semibold text-grayCust-800 md:text-3xl">
        {{ title.split(":")[1] }}
      </h1>
      <p class="mt-3  text-base font-normal text-grayCust-500 sm2:text-lg">
        {{ description }}
      </p>
      <div class="mt-6 flex items-center justify-center">
        <button
          class="mr-6 flex items-center justify-center rounded-lg border border-grayCust-180 bg-white px-5 py-2.5 transform text-sm font-medium text-grayCust-1520 shadow-sm focus:outline-none focus:ring-2  focus:ring-secondary-800 focus:ring-offset-2 focus-visible:outline-none md:mt-0"
          @click="openSupport"
        >
          <svg
            class="mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 8H19C20.1046 8 21 8.89543 21 10V16C21 17.1046 20.1046 18 19 18H17V22L13 18H9C8.44772 18 7.94772 17.7761 7.58579 17.4142M7.58579 17.4142L11 14H15C16.1046 14 17 13.1046 17 12V6C17 4.89543 16.1046 4 15 4H5C3.89543 4 3 4.89543 3 6V12C3 13.1046 3.89543 14 5 14H7V18L7.58579 17.4142Z"
              stroke="#101828"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Get Support
        </button>
        <inertia-link
          v-if="appStore.isTenantTypeInstaWP"
          :href="route('staging')"
          class="flex items-center justify-center rounded-lg border border-transparent bg-secondary-800 px-5 py-2.5 transform text-sm font-medium text-white focus:border-secondary-800 focus:outline-none focus:ring-2 focus:ring-secondary-800 focus:ring-offset-2 focus-visible:outline-none md:mt-0"
        >
          {{ $page.props.auth.user ? 'Go to Dashboard': 'Refresh' }}
        </inertia-link>
        <inertia-link
          v-else
          :href="route('hosting.manager')"
          class="flex items-center justify-center rounded-lg border border-transparent bg-secondary-800 px-5 py-2.5 transform text-sm font-medium text-white focus:border-secondary-800 focus:outline-none focus:ring-2 focus:ring-secondary-800 focus:ring-offset-2 focus-visible:outline-none md:mt-0"
        >
          {{ $page.props.auth.user ? 'Go to Dashboard': 'Refresh' }}
        </inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
import MainLayout from '@/Layouts/MainLayout.vue';
import Setting from '@/setting.js';
import { useAppStore } from '@/store/index';
import { mapStores } from 'pinia';
import { trans } from 'laravel-vue-i18n';

export default {
  name: 'ErrorPage',

  layout: function(h, page) {
    const auth = page.props.auth || {};
    const user = auth.user;

    return user ? h(MainLayout, [page]) : page;
  },

  props: {
    status: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      setting: new Setting()
    }
  },
  computed: {
    title() {
      if (!this.$props.status) {
        return trans('something_went_wrong')
      }
      return {
        503: trans('503_service_unavailable'),
        500: trans('500_server_error'),
        419: trans('419_page_expired'),
        404: trans('404_page_not_found'),
        403: trans('403_forbidden'),
      }[this.status]
    },
    description() {
      if (!this.$props.status) {
        return ''
      }
      return {
        503: trans('error_description_503'),
        500: trans('error_description_500'),
        419: trans('error_description_419'),
        404: trans('error_description_404'),
        403: trans('error_description_403'),
      }[this.status]
    },
    ...mapStores(useAppStore),
  },
  methods: {
    openSupport() {
      const element = document.querySelector('.cc-imbb.cc-qfnu')
      if (element) {
        element.click()
      }
    }
  }
}
</script>
<style scoped>
.error-img{
  height: calc(100vh - 70px);
}
</style>